import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const ReportsView = React.lazy(() => import("../Reports"));

const ReportsLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <ReportsView />
  </React.Suspense>
);
export default () => <ReportsLoadable />;
